import MatchingEventBanners from './MatchingEventBanners'
export type { MatchingEventBannersProps, MatchingEventBannersText } from './MatchingEventBanners'
export type { MatchingEventCampaignType } from './types'
export default MatchingEventBanners
